import React from "react";
import {useForm} from "react-hook-form";
import moment from "moment";
import ServiceService from "@/modules/front/services/ServiceService";
import ProductService from "@/modules/front/services/ProductService";


const ReservationExternalStepExtras = (props) => {
    const [loading, setLoading] = React.useState(true);

    const [services, setServices] = React.useState([]);
    const [selectedServices, setSelectedServices] = React.useState([]);

    const [items, setItems] = React.useState([]);
    const [selectedItems, setSelectedItems] = React.useState([]);

    React.useEffect(() => {
        ServiceService.getAll().then((response) => {
            setServices(response);
        }).catch((error) => {
            console.error('Error:', error);
            alert('Nepodařilo se načíst služby.');
        }
        ).finally(() => {
            setLoading(false);
        });

        ProductService.getRecommendedItems(props.itemId, props.dateFrom, props.dateTo)
            .then((data) => {
                setItems(Object.keys(data).map((key) => data[key]));
            });


    }, []);

    React.useEffect(() => {
        if (props.setSelectedServices) {
            props.setSelectedServices(selectedServices, services, selectedItems, items);
        }
    }, [selectedServices, selectedItems]);






    return <>
        <h2 className={'h5 mt-3 text-uppercase'}>{window.translations.reservationExternal.extras}</h2>
        {loading && <div className={'text-center mt-5'}> Načítám...</div>}
        {!loading && items && items.map((item) => {
            return <div className={'bg-light p-3 mt-3'} key={item.id}>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" value={item.id} id={`item-${item.id}`}
                           onChange={(e) => {
                               if (e.target.checked) {
                                   setSelectedItems([...selectedItems, item.id]);
                               } else {
                                   setSelectedItems(selectedItems.filter((id) => id !== item.id));
                               }
                           }}/>
                    <label className="form-check-label" htmlFor={`item-${item.id}`}>
                        {item.product.title} ({item.pricePerDayFormatted} / den)
                    </label>
                </div>
            </div>;
        })}
        {!loading && services && services.map((service) => {
            return <div className={'bg-light p-3 mt-3'} key={service.id}>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" value={service.id} id={`service-${service.id}`}
                           onChange={(e) => {
                               if (e.target.checked) {
                                   setSelectedServices([...selectedServices, service.id]);
                               } else {
                                   setSelectedServices(selectedServices.filter((id) => id !== service.id));
                               }
                           }}/>
                    <label className="form-check-label" htmlFor={`service-${service.id}`}>
                        {service.name} ({service.priceFormatted})
                    </label>
                </div>
            </div>;
        })}

        {!loading && props.pricingNote &&
        <div className={'small text-black mb-3 me-2 mt-2'}>
            {props.pricingNote}
        </div>}



        <div className={'d-flex justify-content-between mt-4'}>
            <span className={'btn btn-light px-4 py-2 rounded-0 me-3'} onClick={() => props.setStep(1)}><i
                className="fas fa-chevron-left me-3"></i> {window.translations.reservationExternal.back}</span>
            <span className={'btn btn-primary px-4 py-2 rounded-0'} onClick={() => props.setStep(3)}>{window.translations.reservationExternal.next} <i
                className="fas fa-chevron-right ms-3"></i></span>
        </div>
    </>;

};

export default ReservationExternalStepExtras;